import React from 'react';

export const PageContext = React.createContext('indexPage');
export const StoreContext = React.createContext('storeContext');
